import React from 'react'
import { Grid, Typography, CircularProgress } from '@material-ui/core'
import { useSelector } from 'react-redux'

import Room from './Room/Room'
import useStyles from './styles'

const Rooms = ({ currentId, setCurrentId, roomsCategory }) => {
  const { posts, isLoading } = useSelector((state) => state.posts)
  const classes = useStyles()

  if (!posts.length && !isLoading)
    return (
      <Typography variant='body2' style={{ marginTop: '100px' }}>
        No rooms
      </Typography>
    )

  if (isLoading) {
    return <CircularProgress size='4em' style={{ marginTop: '80px' }} />
  }

  return (
    <Grid
      className={classes.container}
      container
      alignItems='stretch'
      spacing={3}
    >
      {posts.map((post) =>
        post.category === roomsCategory ? (
          <Grid key={post._id} item xs={12} sm={12} md={3} lg={3}>
            <Room
              post={post}
              currentId={currentId}
              setCurrentId={setCurrentId}
            />
          </Grid>
        ) : null
      )}
    </Grid>
  )
}

export default Rooms
